import { Navigate } from 'react-router-dom';
import { paths } from 'src/paths';
import { recallPeriod } from './periodHandoff';

/**
 * Where "Back to the period" lands (BOPS-131).
 *
 * The review is the rebill plugin, mounted at its own root, and its back button leaves via a
 * relative `..` — which resolves to the bare mount path. The plugin has no route there, so it
 * rendered its own "Not Found". This sits on that path instead and forwards to the period page,
 * handing back the row the page needs to render.
 *
 * With no row parked — the review URL opened cold, from a bookmark or a shared link — the period
 * page has nothing to render and would show today's dates against an empty range, so Closeout
 * Alerts is the honest destination: it is where a period gets picked, and it is the sidebar entry
 * already lit while the review is open.
 */
const BackToPeriodRedirect = () => {
  const period = recallPeriod();

  if (!period)
    return (
      <Navigate
        to={paths.monthlyCloseoutAlert}
        replace
      />
    );

  return (
    <Navigate
      to={`/${paths.monthDayAlert}`}
      state={period}
      replace
    />
  );
};

export default BackToPeriodRedirect;
